export default __webpack_public_path__ + "static/media/AcceleronsGallery_35.bfa24159.JPG";